import * as Separator from '@radix-ui/react-separator';

import { styled } from '@lichtblick/styled';

export const StyledSeparator = styled(Separator.Root)<{ color: string }>`
  background-color: ${({ color }) => color};
  &[data-orientation='vertical'] {
    height: 100%;
    width: 1px;
  }

  &[data-orientation='horizontal'] {
    height: 1px;
    width: 100%;
  }
`;
